import { client } from "../client/client";

export const getAllBranches = async () => {
  try {
    const response = await client.get(`/branch`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addBranch = async (name, city) => {
  try {
    const response = await client.post(`/branch`, {
      name,
      city,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteBranch = async (id) => {
  try {
    const response = await client.delete(`/branch/${id}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
